import React, { useContext, useEffect, useRef, useState } from 'react'
import { store } from '../../stores/pages'
import classNames from 'classnames'
import ReactDOM from 'react-dom'
import Uploads from '../Uploads'

export default function PageBlocks() {
  const context = useContext(store)
  const { blocks, preview, dispatch, actions, hideGraphics } = context

  const enableGraphics = hideGraphics ? false : true

  const [imageMenuState, setImageMenuState] = useState({
    open: false,
    category: null,
    blockId: null,
    onSelectUpload: () => { },
  })

  const imageMenuRef = useRef()

  useEffect(() => {
    dispatch({ type: actions.UPDATE_HTML })
  }, [preview])

  const handleMessage = (event) => {
    if (!event.isTrusted) return
    switch(event.data.type) {
      case 'blockUpdates':
        dispatch({ type: actions.SET_BLOCKS, payload: event.data.payload })
        break;
      case 'openImageSelector':
        const { id, multi } = event.data;
        setImageMenuState({
          open: true,
          category: 'photo',
          blockId: id,
          multi: multi,
          onSelectUpload: (upload) => {
            const event = document.createEvent('Event')
            event.initEvent('uploadSelected', true, true)

            event.detail = {
              id: id,
            }

            if (upload) {
              switch(upload.type) {
                case "graphic":
                  event.detail = {
                    id: id,
                    image: {
                      id: upload.id,
                      type: "graphic",
                      formats: upload.attributes.formats,
                      full_urls: upload.attributes.full_urls,
                    }
                  }
                  break
                case "upload":
                  event.detail = {
                    id: id,
                    image: {
                      id: upload.id,
                      type: "graphic",
                      formats: upload.attributes.formats,
                      full_urls: upload.attributes.full_urls,
                    }
                  }
                  break
              }
            }

            document.dispatchEvent(event)
            setImageMenuState({
              open: false,
            })
          },
        })
        break;
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (imageMenuState.open) {
      const handleKeyDown = (e) => {
        if (e.keyCode == 27) { // esc
          setImageMenuState({
            open: false
          })
        }
      }

      const handleMouseDown = (e) => {
        if (imageMenuState.open &&
          imageMenuState.current &&
          !imageMenuState.current.contains(e.target) &&
          !e.target.closest('.form-select-upload') &&
          !e.target.closest('.pintura-editor') &&
          !e.target.closest('.modal')) {
          setImageMenuState({
            open: false
          })
        }
      }
      window.addEventListener("keydown", handleKeyDown, false)
      window.addEventListener("mousedown", handleMouseDown, false)

      return () => {
        window.removeEventListener("keydown", handleKeyDown)
        window.removeEventListener("mousedown", handleMouseDown)
      }
    }
  }, [imageMenuState.open])

  const imageMenuClasses = classNames({
    'uploads-menu': true,
    'open': imageMenuState.open,
    'uploads-menu-demo': context.demo,
  })

  const imagesMenu = ReactDOM.createPortal((
    <div className={imageMenuClasses} ref={imageMenuRef}>
      <Uploads
        {...context}
        selfSignUpTrial={false}
        actsAsMenu={true}
        enableGraphics={enableGraphics}
        demo={context.demo}
        key={imageMenuState.category}
        uploadMenuState={imageMenuState} />
    </div>
  ), document.body)

  return (
    <>
      <input type="hidden" name="editor" value={!preview} />
      <input type="hidden" name="blocks" value={JSON.stringify(blocks)} />
      {imagesMenu}
    </>
  )
}
